export const inputCls =
  "w-full bg-white border-2 border-gray-300 focus:border-brand-red px-4 py-3.5 outline-none font-body text-brand-dark text-base transition-colors";

export const labelCls =
  "block text-base font-heading uppercase tracking-wider text-brand-dark mb-2 font-semibold";

export const btnPrimaire =
  "bg-brand-red hover:bg-brand-redhover text-white font-heading font-semibold uppercase tracking-wider text-lg px-8 py-4 transition-colors disabled:opacity-60";

export const btnSecondaire =
  "bg-brand-dark hover:bg-black text-white font-heading font-semibold uppercase tracking-wider text-lg px-6 py-3.5 transition-colors";

export const btnDanger =
  "bg-white border-2 border-brand-redhover text-brand-redhover hover:bg-brand-redhover hover:text-white font-heading font-semibold uppercase tracking-wider px-5 py-3 transition-colors";

export const dateFr = (iso) => (iso ? iso.split("-").reverse().join("/") : "");

export const dateHeureFr = (iso) => {
  if (!iso) return "";
  const d = new Date(iso);
  return d.toLocaleDateString("fr-FR") + " à " + d.toLocaleTimeString("fr-FR", { hour: "2-digit", minute: "2-digit" });
};

export function confirmerSuppression(nom) {
  return window.confirm(`Supprimer définitivement « ${nom} » ? Cette action est irréversible.`);
}
